import { AppTooltip } from '../ui/AppTooltip';

export const LanguageSelector = ({ value, onChange, label }) => (
  <div>
    <label className='sr-only' htmlFor='language-selector'>
      {label}
    </label>
    <AppTooltip label={label} placement='bottom'><select
      id='language-selector'
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className='h-10 rounded-[var(--radius-md)] border border-[var(--border-subtle)] bg-[var(--surface-panel)] px-3 text-sm font-semibold text-[var(--text-secondary)] shadow-sm'
    >
      <option value='es'>ES</option>
      <option value='en'>EN</option>
    </select></AppTooltip>
  </div>
);
